import React from "react";
import { CustomTableRow, CustomTableCell } from "../../../../common/components";
import { translate } from "../../../../common/providers";

const HeaderDeliverableRow = ({ order, orderBy, onSort }) => (
	<CustomTableRow>
		<CustomTableCell active={orderBy === "name"} direction={order} sortKey="name" onSort={() => onSort("name")}>
			{translate("deliverables-list.header.name")}
		</CustomTableCell>
		<CustomTableCell active={orderBy === "ref"} direction={order} sortKey="ref" onSort={() => onSort("ref")}>
			{translate("deliverables-list.header.ref")}
		</CustomTableCell>
		<CustomTableCell active={orderBy === "type"} direction={order} sortKey="type" onSort={() => onSort("type")}>
			{translate("deliverables-list.header.type")}
		</CustomTableCell>
		<CustomTableCell
			active={orderBy === "format"}
			direction={order}
			sortKey="format"
			onSort={() => onSort("format")}
		>
			{translate("deliverables-list.header.format")}
		</CustomTableCell>
		<CustomTableCell active={orderBy === "phase"}>{translate("deliverables-list.header.phase")}</CustomTableCell>
		<CustomTableCell active={orderBy === "owner"}>{translate("deliverables-list.header.owner")}</CustomTableCell>
		<CustomTableCell active={orderBy === "categories"}>
			{translate("deliverables-list.header.categories")}
		</CustomTableCell>
		<CustomTableCell />
	</CustomTableRow>
);

export default HeaderDeliverableRow;
